import AppDispatcher from '../dispatcher/AppDispatcher';
import AuthConstants from '../constants/AuthConstants';
import AuthAPI from '../utils/AuthAPI';

export default {

  logUserIn: (login, password, pack_password) => {
    AuthAPI
      .logUserIn(login, password, pack_password)
      .then(session => {
        session.login = login
        session.password = password
        session.pack_password = pack_password
        AppDispatcher.dispatch({
          actionType: AuthConstants.LOGIN_USER,
          session: session
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: AuthConstants.LOGIN_USER_ERROR,
          message: message
        });
      });
  },

  logUserOut: () => {
    AppDispatcher.dispatch({
      actionType: AuthConstants.LOGOUT_USER
    });
  }

}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js